module.exports = __webpack_public_path__ + "static/media/plus_icon.5b03c368.svg";